//fda512bb-f507-4f52-a73a-58c0e49a1175#1a0b31d4-ef0e-4605-bdc8-72fa3f26c890
import React from 'react'
import {FORM_STYLE} from "./item.jsx";
import {Icon, Message} from "semantic-ui-react";

export default class ItemErrorHandler extends React.Component {

    constructor(props) {
        super(props);
        this.state = {errorOccurred: false, errorInfo: ""};
    }

    static getDerivedStateFromError(error) {
        console.error(error);
        return {errorOccurred: true, errorInfo: error.message + "\n" + error.stack};
    }

    render() {
        const {errorOccurred, errorInfo} = this.state;
        if (errorOccurred) {
            return (
                <div style={FORM_STYLE}>
                    <Message negative icon size='massive'>
                        <Icon name='bug'/>
                        <Message.Content>
                            <Message.Header>An unforeseen error occurred</Message.Header>

                        </Message.Content>
                    </Message>
                    <pre style={{
                        wordBreak: 'break-word',
                        whiteSpace: 'pre-line'
                    }}> {errorInfo}</pre>
                </div>
            )
        } else {
            return this.props.children;
        }

    }
}
